import React, { useEffect, useState } from 'react'; 
import styles from './../../Assets/CSS/Login.module.css';
import axios from 'axios';
import { BASE_URL } from './../../Environment';
import loginImg from './../../Assets/Images/loginImage.svg';
import { FaIdCardAlt, FaKey, FaLock } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import { BlueButton } from './../../Components/Button';
import { toast } from 'react-toastify';
   
function ForgotPassword() {   
    const navigate = useNavigate(); 
    const [isLoading, setIsLoading] = useState(false);
    const [get_otp, setGetOtp] = useState(true);
    const [verify_otp, setVerifyOtp] = useState(false);
    const [reset_password, setResetPassword] = useState(false); 
    const [id, setId] = useState('');  
    const [email, setEmail] = useState(''); 
    const [otp, setOtp] = useState('');
    const [new_password, setNewPassword] = useState('');
    const [confirm_password, setConfirmPassword] = useState('');   
    useEffect(() => { 
        document.title = 'Infomart | Agent Forgot Password';
    }, []);     
    const handleGetOtp = async () => { 
        setIsLoading(true); 
        await axios.post(`${BASE_URL}/agent/fp-get-otp`, { email }, {
            headers: {  
                'Content-Type': 'application/json'
            }
        }).then((res) => {
            setId(res.data.id);  
            toast.success(res.data.msg, { autoClose: 3000 });
            setIsLoading(false); 
            setGetOtp(false); 
            setVerifyOtp(true); 
            setResetPassword(false);  
        }).catch((res) => {    
            toast.error(res.response.data.msg, { autoClose: 3000 }); 
            setIsLoading(false);  
        });   
    }       
    const handleVerifyOtp = async () => { 
        setIsLoading(true); 
        await axios.post(`${BASE_URL}/agent/fp-verify-otp`, { id, otp }, {
            headers: {   
                'Content-Type': 'application/json'
            }
        }).then((res) => {
            toast.success(res.data.msg, { autoClose: 3000 });
            setIsLoading(false);  
            setGetOtp(false);  
            setVerifyOtp(false); 
            setResetPassword(true);  
        }).catch((res) => {    
            toast.error(res.response.data.msg, { autoClose: 3000 }); 
            setIsLoading(false);  
        });   
    }
    const handleResetPassword = async () => { 
        setIsLoading(true); 
        await axios.post(`${BASE_URL}/agent/fp-reset-password`, { id, new_password, confirm_password }, {
            headers: {      
                'Content-Type': 'application/json'
            }
        }).then((res) => {
            toast.success(res.data.msg, { autoClose: 3000 });
            setIsLoading(false);  
            navigate('/agent/login'); 
        }).catch((res) => {    
            toast.error(res.response.data.msg, { autoClose: 3000 }); 
            setIsLoading(false);  
        });     
    }   
    return (
        <div className="app"> 
            <div className="outlet">
                <div className={styles.loginPageContainer}>
                    <div className={styles.loginFormContainer}>
                        <div className={styles.imgContainer}>
                            <img src={loginImg} className={styles.img} />
                        </div>
                        <div className={styles.contentContainer}> 
                            <h3>Forgot Password</h3> 
                            {get_otp ?
                                <>
                                    <div className={styles.loginForm}>
                                        <div className={styles.inputContainer}>
                                            <input type="text" className={styles.input} placeholder="Enter Email ID *" onChange={e => setEmail(e.target.value)} />
                                            <FaIdCardAlt color="gray" />
                                        </div> 
                                        <Link to="/agent/login" className={styles.link}>Back to Login</Link>
                                    </div>    
                                    <div>
                                        <BlueButton title={isLoading ? "Loading..." : "Get OTP"} onClick={() => handleGetOtp()} />
                                    </div> 
                                </> 
                            : null }
                            {verify_otp ?
                                <>
                                    <div className={styles.loginForm}>
                                        <div className={styles.inputContainer}>
                                            <input type="number" className={styles.input} placeholder="Enter OTP *" onChange={e => setOtp(e.target.value)} />
                                            <FaKey color="gray" />  
                                        </div>  
                                        <Link to="/agent/login" className={styles.link}>Back to Login</Link>
                                    </div>    
                                    <div>
                                        <BlueButton title={isLoading ? "Loading..." : "Verify OTP"} onClick={() => handleVerifyOtp()} />
                                    </div> 
                                </>  
                            : null } 
                            {reset_password ?
                                <>
                                    <div className={styles.loginForm}>
                                        <div className={styles.inputContainer}>
                                            <input type="password" className={styles.input} placeholder="Enter New Password *" onChange={e => setNewPassword(e.target.value)} />
                                            <FaLock color="gray" />
                                        </div>
                                        <div className={styles.inputContainer}>
                                            <input type="password" className={styles.input} placeholder="Enter Confirm Password *" onChange={e => setConfirmPassword(e.target.value)} />
                                            <FaLock color="gray" />  
                                        </div>   
                                        <Link to="/agent/login" className={styles.link}>Back to Login</Link>
                                    </div>    
                                    <div>
                                        <BlueButton title={isLoading ? "Loading..." : "Reset Password"} onClick={() => handleResetPassword()} />
                                    </div>   
                                </> 
                            : null }   
                        </div>
                    </div>
                </div>
            </div> 
        </div>
    );
}

export default ForgotPassword;      